// extracted by mini-css-extract-plugin
export default {"error":"FormError_error__G1wBR","heading":"FormError_heading__TqE80"};